import { CmsAttachedBlocks, pickAttachedBlocks, pickCompactBlocks } from '@longy/common/cms'
import { PageRenderer } from '@longy/web-components/cms'
import { ReactElement } from 'react'

import { useLocale } from '../../hooks/useLocale'

export const useAttachedBlocks = (attached: CmsAttachedBlocks | undefined, compact = false) => {
    const { locale } = useLocale()
    const blocks = pickAttachedBlocks(attached ?? {}, locale)
    return compact ? pickCompactBlocks(blocks) : blocks
}

export const AttachedBlocks = ({
    blocks,
    compact = false,
    className,
}: {
    blocks: CmsAttachedBlocks | undefined
    compact?: boolean
    className?: string
}): ReactElement | null => {
    const { locale } = useLocale()
    const picked = useAttachedBlocks(blocks, compact)
    if (picked.length === 0) return null

    return (
        <div className={className}>
            <PageRenderer blocks={picked} locale={locale} />
        </div>
    )
}
